'use strict';
import api from 'utils/api';
import Immutable from 'immutable';
import flatten from 'lodash/array/flatten';
import uniq from 'lodash/array/uniq';
import flux from 'utils/flux';

const BasketSource = alt => {
    return {
        loadBaskets: {
            local( state, basketId ) {
                if ( basketId ) {
                    var basketExits = state.baskets.findIndex( basket => basketId === basket.get('id') );

                    if ( basketExits !== -1 ) {
                        var baskets = state.baskets.toJS().map( basket => {
                            basket.isSelected = false;
                            return basket;
                        });

                        alt.getActions('basket').loadBasketsSuccess({
                            baskets: baskets,
                            basketId: basketId
                        });

                        return true;
                    }
                }
            },
            remote( state, basketId ) {
                return api.get('basket').then( baskets => {
                    // console.log(baskets);
                    //
                    // for (var i=0; i<baskets[0].items.length; i++) {
                    //
                    //     var allitems = baskets[0].items;
                    //     for (var j=0; j<allitems.length; j++) {
                    //         var allFiles  = allitems[j].files;
                    //         for (var z=0; z<allFiles.length; z++){
                    //             console.log(allFiles[z].key);
                    //
                    //             if (allFiles[z].key.indexOf("--")>-1) {
                    //                 allFiles[z].key = allFiles[z].key.substring(0, allFiles[z].key.indexOf("-"));
                    //             }
                    //
                    //         }
                    //     }
                    // }



                    return { baskets, basketId };
                });
            },
            success: alt.getActions('basket').loadBasketsSuccess,
            error: alt.getActions('basket').loadError
        },
        addToBasket: {
            remote( state, payload ) {
                var { basket, media } = payload;
                media = !Array.isArray( media ) ? [ media ] : media;
                // console.log('addToBasket, payload `media`:', media);
                return api.post( 'basket/' + basket.id, media ).then( data => {
                    return {
                        basket: data,
                        media: media
                    };
                });
            },
            success: alt.getActions('basket').addToBasketSuccess,
            error: alt.getActions('basket').loadError
        },
        createBasket: {
            remote( state, media, basketName = false ) {
                // console.log('create basket', JSON.stringify(media.map(item => item.id)), media.length);
                var payload = {
                    media
                };
                if ( basketName ) {
                    payload.name = basketName;
                }
                return api.post( 'basket', payload ).then( data => {
                    return {
                        newBasket: data.filter( basket => basket.isNew )[0],
                        media: media
                    };
                });
            },
            success: alt.getActions('basket').createBasketSuccess,
            error: alt.getActions('basket').createBasketError
        },

        //
        // Edt a baskets name
        editBasketName: {
            remote( state, basketId, basketName ) {
                return api.post( 'basket/' + basketId + '/edit', {
                    id: basketId,
                    name: basketName
                }).then( result => {
                    return { basketId: result.id, basketName: result.name };
                });
            },
            success: alt.getActions('basket').editBasketNameSuccess,
            error: alt.getActions('basket').loadError
        },

        //
        // Share a basket
        shareBaskets: {
            local() {
                alt.getActions('basket').resetShareUrl();
                return null;
            },
            remote( state, basketIds ) {
                return api.post( 'basket/share', {
                    basket_ids: basketIds
                });
            },
            success: alt.getActions('basket').shareBasketsSuccess,
            error: alt.getActions('basket').loadError
        },

        //
        // Request License
        requestLicensing: {
            remote( state, basketId, requests ) {
                return api.post( 'basket/' + basketId + '/request_licence', {
                    requests: requests
                });
            },
            success: alt.getActions('basket').requestLicensingSuccess,
            error: alt.getActions('basket').loadError
        },

        //
        // Delete a single basket
        deleteBasketItem: {
            remote( state, mediaId ) {
                return api.post('basket/delete/' + state.basket.get('id') + '/' + mediaId);
            },
            success: alt.getActions('basket').deleteBasketItemSuccess,
            error: alt.getActions('basket').loadError
        },

        //
        // Delete multiple baskets
        deleteBaskets: {
            remote( state, basketIds ) {
                return Promise.all( basketIds.map( basketId => api.post('basket/delete/' + basketId) ) ).then( () => {
                    return basketIds;
                });
            },
            success: alt.getActions('basket').deleteBasketsSuccess,
            error: alt.getActions('basket').loadError
        }
    };
};

export default class BasketStore {
    constructor() {
        this.bindActions( this.alt.getActions('basket') );
        this.registerAsync( BasketSource );

        this.baskets        = Immutable.fromJS([]);
        this.basket         = Immutable.fromJS({});
        this.shareUrl       = null;
        this.activeBasketId = null;
    }

    onLoadBasketsSuccess( data ) {
        var { baskets, basketId } = data;
        this.baskets = Immutable.fromJS( baskets );

        if ( !basketId && this.baskets.size > 0 ) {
            basketId = this.baskets.last().get('id');
        }

        if ( basketId ) {
            this.basket = this.baskets.filter( basket => basketId === basket.get('id') ).first();

            if ( this.basket ) {
                this.basket = this._prepareBasketItem( this.basket );
                this.basket = this._prepareBasketItemWithFileName( this.basket );
            } else {
                this.basket = Immutable.fromJS({});
            }

            this._setActiveBasketId( basketId );
            this.onToggleBasketSelection( basketId );
        }
    }

    _prepareBasketItem(basket) {
        var files = flatten( basket.toJS().items.map((item) => item.files) ).map((file) => {
            return {key: file.key, name: file.name};
        });

        this._setActiveBasketId( basket.get('id') );
        return basket.set('_filekeys', Immutable.fromJS(uniq(files, 'key')));
    }

    _prepareBasketItemWithFileName(basket) {
        var files = flatten( basket.toJS().items.map((item) => item.files) ).map((file) => {
            return {key: file.key, name: file.name};
        });

        this._setActiveBasketId( basket.get('id') );
        return basket.set('_filenames', Immutable.fromJS(uniq(files, 'name')));
    }

    _setActiveBasketId( basketId ) {
        this.activeBasketId = basketId;
    }

    onAddToBasketSuccess(result) {
        var { media, basket } = result;
        var ix = this.baskets.findIndex( item => item.get('id') === basket.id );
        this.baskets = this.baskets.updateIn( [ix, 'items'], () => Immutable.fromJS( basket.items ) );

        // Set Last used Basket
        this._setActiveBasketId( basket.id );

        setTimeout( () => {
            var notifications = this._generateSuccessNotifications( media, basket.name );
            this.alt.getActions('notifications').addSuccessNotification( notifications );
        }, 10 );
    }

    _generateSuccessNotifications(media, basketName) {
        // Add Success for Each item
        return media.map( item => {
            var text = this.alt.getStore('translations').getFormattedMessage('notification_add_to_basket_success', {
                mediaName: item.title || item.name,
                basketName: basketName
            });
            return {
                text: text,
                type: 'success',
                mediaId: item.id
            };
        });
    }

    onCreateBasketSuccess(result) {
        var {media, newBasket} = result;
        this.baskets = this.baskets.push(Immutable.fromJS(newBasket));

        // Set Last used Basket
        this._setActiveBasketId(newBasket.id);
        this.basket = this._prepareBasketItem(Immutable.fromJS(newBasket));
        this.basket = this._prepareBasketItemWithFileName(Immutable.fromJS(newBasket));

        setTimeout(() => {
            var notifications = this._generateSuccessNotifications(media, newBasket.name);
            this.alt.getActions('notifications').addSuccessNotification(notifications);
        }, 10);
    }

    createBasketError(result) {

    }

    onEditBasketNameSuccess(result) {
        var {basketId, basketName} = result;
        var ix = this.baskets.findIndex((item) => item.get('id') === basketId);
        this.baskets = this.baskets.updateIn([ix, 'name'], () => basketName);
        this.basket = this.basket.updateIn(['name'], () => basketName);
    }

    onDeleteBasketItemSuccess(basket) {
        flux.getStore('basket').loadBaskets();
        this.basket = this._prepareBasketItem(Immutable.fromJS(basket));
        this.basket = this._prepareBasketItemWithFileName(Immutable.fromJS(basket));
    }

    onResetShareUrl() {
        this.shareUrl = null;
    }

    onShareBasketsSuccess(shared) {
        this.shareUrl = shared.fullurl;
    }

    onToggleDownload(result) {
        var { itemId, fileKey } = result;
        var items = this.basket.get('items');
        var itemIx = items.findIndex( item => item.get('id') === itemId );

        items = items.updateIn([itemIx, 'files'], files => {
            var fileIx = files.findIndex((file) => file.get('name') === fileKey);
            return files.updateIn([fileIx], (sfile) => {
                return sfile.set('_download', !sfile.get('_download'));
            });
        });

        this.basket = this.basket.set('items', items);
    }

    /**
     * Toggles the "isSelected Flag" on a basket
     * @param  {string} basketId
     * @return {obj}
     */
    onToggleBasketSelection(basketId) {
        this.baskets = this.baskets.update(
            this.baskets.findIndex((item) => item.get('id') === basketId),
            (item) => item.set('isSelected', !item.get('isSelected'))
        );
    }

    /**
     * sets the text for a licensing request
     */
    onUpdateLicensingUsageText(data) {
        var items = this.basket.get('items');
        items = items.update(
            items.findIndex((item) => item.get('id') === data.itemId),
            (item) => item.set('_usageText', data.text)
        );
        this.basket = this.basket.set('items', items);
    }

    /**
     * Marks a single item for licensing request
     */
    onToggleLicensing(itemId) {
        var items = this.basket.get('items');
        items = items.update(
            items.findIndex((item) => item.get('id') === itemId),
            (item) => item.set('_requestLicense', !item.get('_requestLicense'))
        );

        this.basket = this.basket.set('items', items);
    }

    /**
     * Marks all basket items to be requested for licensing
     */
    onToggleLicensingAll() {

        var items = this.basket.get('items');

        var areChecked = items.filter((item) => item.get('_requestLicense') === true).size;
        var shouldCheck = (areChecked === items.size ? false : true);

        items = items.map((item) => {
            return item.set('_requestLicense', shouldCheck);
        });
        this.basket = this.basket.set('items', items);
    }

    onToggleDownloadAll(fileKey) {
        var shouldGetChecked = !BasketStore.fileIsChecked(this.basket, fileKey);
        var items = this.basket.get('items');
        items = items.map((item) => {
            var files = item.get('files').map((file) => {
                if (file.get('name') === fileKey) {
                    return file.set('_download', shouldGetChecked);
                }
                return file;
            });
            return item.set('files', files);
        });

        this.basket = this.basket.set('items', items);
    }

    onDeleteBasketsSuccess(basketIds) {
        var baskets = this.baskets;
        basketIds.forEach((basketId) => {
            let ix = baskets.findIndex((item) => item.get('id') === basketId);
            baskets = baskets.removeIn([ix]);
        });
        this.baskets = baskets;
        if (baskets.size === 0) {
            this.basket = Immutable.fromJS({});
        }
    }

    /**
     * Filters an immutable array of baskets by the isSelected property
     * @param  {ImmutableArr} baskets
     * @return {ImmutableArr} filteredBaskets
     */
    static getSelectedBaskets(baskets) {
        if (baskets.size === 0) {
            return baskets;
        }
        return baskets.filter((basket) => basket.get('isSelected') === true);
    }

    static isInBasket(basket, mediaId) {
        return (basket.items.filter((media) => media.id === mediaId).length > 0 ? true : false);
    }

    static getItemsToDownload(items) {
        return flatten(items.map((item) => {
            var itemId = item.id;
            return item.files.filter((file) => file._download).map((file) => {
                return {id: itemId, size: file.key};
            });
        }));
    }

    static fileIsChecked(basket, fileKey) {
        var basketFiles = basket.get('items').map((item) => {
            return item.get('files').filter((s) => s.get('name') === fileKey);
        }).reduce(((x, v) => x.concat(v)), Immutable.List([]));

        return basketFiles.filter((item) => item.get('_download')).size === basketFiles.size;
    }
}



// WEBPACK FOOTER //
// ./app/stores/basketStore.js